import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.dizest.editor.workflow.sidebar.code');
import { OnInit, Input } from '@angular/core';
import { ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-dizest-editor-workflow-sidebar-code',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.dizest.editor.workflow.sidebar.code/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

nu-monaco-editor {
  display: block;
  min-height: 105px;
}

.code-area nu-monaco-editor {
  width: 100%;
}`],
})
export class PortalDizestEditorWorkflowSidebarCodeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @ViewChild('scrollelement')
    public scrollElement: ElementRef;

    @Input() app: any;
    @Input() sidebar: any;

    public workflow: any;
    public codeflow: any = {};
    public onEditorScroll: boolean = false;
    private _codeChangeTimer: any = null;
    private static readonly CODE_CHANGE_DELAY = 1000;
    private _metaChangeTimer: any = null;
    private static readonly META_CHANGE_DELAY = 500;

    public async ngOnInit() {
        await this.service.init();
        this.workflow = this.app.workflow;
        await this.service.render();

        this.sidebar.getFlow = async () => {
            if (!this.workflow.node.selected) return;
            let flow = this.flow(this.workflow.node.selected);
            return { flow: flow, codeflow: this.codeflow[this.workflow.node.selected] };
        }
    }

    /**
     * Re-layout all visible Monaco editors.
     * Called from onSidebarShow and externally from editor.workflow (onEditorShow).
     */
    public async monaco_auto_height() {
        for (let flow_id in this.codeflow) {
            let cf = this.codeflow[flow_id];
            if (cf && cf.show && cf.flow && cf.flow.editor) {
                try {
                    this.updateEditorHeight(cf.flow.editor);
                } catch (e) { }
            }
        }
    }

    public async onSidebarShow() {
        await new Promise(resolve => requestAnimationFrame(resolve));
        await this.monaco_auto_height();
        setTimeout(() => this.monaco_auto_height(), 150);
    }

    public flow(flow_id) {
        if (this.codeflow[flow_id]) return this.codeflow[flow_id].flow;
        this.codeflow[flow_id] = {};
        let flow = this.workflow.spec.flow(flow_id);
        this.codeflow[flow_id].flow = flow;
        this.codeflow[flow_id].target = 'code';
        this.codeflow[flow_id].monaco = this.monacoopt('python');
        this.codeflow[flow_id].show = true;
        return flow;
    }

    public monacoopt(language: string = 'python') {
        let opt = {
            value: '',
            language: language,
            theme: "vs",
            fontSize: 14,
            automaticLayout: true,
            scrollBeyondLastLine: false,
            wordWrap: true,
            roundedSelection: false,
            glyphMargin: false,
            scrollbar: {
                vertical: "hidden",
                handleMouseWheel: false,
            },
            minimap: {
                enabled: false
            }
        }
        return opt;
    }

    public async select(flow_id) {
        this.workflow.node.selected = flow_id;
        await this.workflow.moveToFlow(flow_id);
        await this.app.service.render();
    }

    public async close(flow_id) {
        this.disposeEditor(flow_id);
        this.sidebar.items.remove(flow_id);
        this.workflow.node.selected = null;
        await this.app.service.render();
    }

    public async changeTargetCode(flow_id, target) {
        this.disposeEditor(flow_id);

        this.codeflow[flow_id].show = false;
        await this.service.render();

        let languageMap: any = { code: 'python', html: 'html', js: 'javascript', css: 'scss', api: 'python' };
        let language = languageMap[target];

        this.codeflow[flow_id].target = target;
        this.codeflow[flow_id].monaco = this.monacoopt(language);
        this.codeflow[flow_id].show = true;

        await this.service.render();
    }

    /**
     * Track code change (code/html/js/css/api) with debounce.
     */
    private trackCodeChange(flow_id: string) {
        if (this._codeChangeTimer) clearTimeout(this._codeChangeTimer);
        this._codeChangeTimer = setTimeout(() => {
            this._codeChangeTimer = null;
            let flow = this.codeflow[flow_id]?.flow;
            if (!flow) return;
            let app = flow.app();
            if (!app) return;
            let target = this.codeflow[flow_id]?.target || 'code';
            this.workflow.spec.trackChange('app', 'update', app.id(), [target]);
        }, Component.CODE_CHANGE_DELAY);
    }

    /**
     * Track flow title or app category change with debounce.
     */
    public onFlowTitleChange(flow_id: string) {
        if (this._metaChangeTimer) clearTimeout(this._metaChangeTimer);
        this._metaChangeTimer = setTimeout(() => {
            this._metaChangeTimer = null;
            this.workflow.spec.trackChange('flow', 'update', flow_id, ['title']);
        }, Component.META_CHANGE_DELAY);
    }

    public onAppCategoryChange(flow_id: string) {
        if (this._metaChangeTimer) clearTimeout(this._metaChangeTimer);
        this._metaChangeTimer = setTimeout(() => {
            this._metaChangeTimer = null;
            let flow = this.codeflow[flow_id]?.flow;
            if (!flow) return;
            let app = flow.app();
            if (!app) return;
            this.workflow.spec.trackChange('app', 'update', app.id(), ['category']);
        }, Component.META_CHANGE_DELAY);
    }

    /**
     * Dispose editor event listeners for a given flow_id.
     */
    private disposeEditor(flow_id: string) {
        let cf = this.codeflow[flow_id];
        if (!cf) return;
        if (cf.disposables) {
            cf.disposables.forEach(d => {
                try { d.dispose(); } catch (e) { }
            });
            cf.disposables = [];
        }
        if (cf.flow) {
            cf.flow.editor = null;
        }
    }

    /**
     * Calculate and apply the correct height for a Monaco editor
     * using Monaco's built-in getContentHeight() API.
     */
    private updateEditorHeight(editor: any) {
        if (!editor) return;
        const el = editor.getDomNode();
        if (!el) return;

        let contentHeight: number;
        try {
            contentHeight = editor.getContentHeight();
        } catch (e) {
            const lineCount = editor.getModel()?.getLineCount() || 1;
            contentHeight = lineCount * 21;
        }

        let height = Math.max(contentHeight, 105);

        let documentHeight = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight
        );
        const maxHeight = documentHeight - 104;
        if (height > maxHeight) height = maxHeight;

        el.style.height = height + 'px';
        editor.layout();
    }

    /**
     * Monaco editor init event handler.
     * Uses getContentHeight() + onDidContentSizeChange for robust auto-height.
     */
    public async init(event: any, flow_id: string) {
        if (event.type !== 'init') return;

        let { editor } = event;
        if (!editor) return;

        let flow = this.flow(flow_id);
        flow.editor = editor;

        if (!this.codeflow[flow_id].disposables) {
            this.codeflow[flow_id].disposables = [];
        }

        const el = editor.getDomNode();
        if (!el) return;

        el.style.minHeight = '105px';

        // Force initial layout with requestAnimationFrame to ensure DOM is ready
        let layoutRetry = (delay: number) => {
            setTimeout(() => {
                try {
                    editor.layout();
                    this.updateEditorHeight(editor);
                } catch (e) { }
            }, delay);
        };

        // Immediate layout
        requestAnimationFrame(() => {
            try {
                editor.layout();
                this.updateEditorHeight(editor);
            } catch (e) { }
        });

        // Retry layouts at multiple timings to handle async rendering
        layoutRetry(50);
        layoutRetry(150);
        layoutRetry(400);

        // Listen for content size changes (typing, wrapping, model change)
        try {
            const sizeDisposable = editor.onDidContentSizeChange(() => {
                this.updateEditorHeight(editor);
            });
            this.codeflow[flow_id].disposables.push(sizeDisposable);
        } catch (e) {
            // Fallback: use onDidChangeModelContent
            try {
                const contentDisposable = editor.getModel().onDidChangeContent(() => {
                    this.updateEditorHeight(editor);
                });
                this.codeflow[flow_id].disposables.push(contentDisposable);
            } catch (e2) { }
        }

        // Track code changes for auto-patch
        try {
            const changeDisposable = editor.getModel().onDidChangeContent(() => {
                this.trackCodeChange(flow_id);
            });
            this.codeflow[flow_id].disposables.push(changeDisposable);
        } catch (e) { }

        // Scroll pass-through handling
        const container = this.scrollElement?.nativeElement;
        if (container && el) {
            el.addEventListener('wheel', (event) => {
                this.onEditorScroll = true;
                const editorScrollTop = editor.getScrollTop();
                const editorScrollHeight = editor.getScrollHeight();
                const editorHeight = el.offsetHeight;
                const recty = el.getBoundingClientRect().y;

                if (event.deltaY > 0) {
                    if (editorScrollTop + editorHeight >= editorScrollHeight) {
                        container.scrollTop += event.deltaY;
                    } else {
                        if (recty > 104) {
                            container.scrollTop += event.deltaY;
                        } else {
                            editor.setScrollTop(editorScrollTop + event.deltaY);
                        }
                    }
                } else {
                    if (editorScrollTop == 0) {
                        container.scrollTop += event.deltaY;
                    } else {
                        if (recty < 104) {
                            container.scrollTop += event.deltaY;
                        } else {
                            editor.setScrollTop(editorScrollTop + event.deltaY);
                        }
                    }
                }
                this.onEditorScroll = false;
                event.preventDefault();
            });
        }
    }
}

export default PortalDizestEditorWorkflowSidebarCodeComponent;